import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let SBProMenuDocumentation = class SBProMenuDocumentation extends Vue {
};
SBProMenuDocumentation = __decorate([
    Component({})
], SBProMenuDocumentation);
export default SBProMenuDocumentation;
